import React from "react";
import { Check, Zap } from "lucide-react";
import { siteData } from "../mock";

const Approach = () => {
  return (
    <section className="relative py-28 bg-[#080b14] overflow-hidden">
      <div className="aurora float-med" style={{ width: 500, height: 500, background: "#8b5cf6", top: "-10%", left: "-10%", opacity: 0.3 }} />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          {/* decorative frames */}
          <div className="absolute -top-6 -left-6 w-32 h-32 rounded-2xl border border-blue-400/30" />
          <div className="absolute -bottom-6 -right-6 w-24 h-24 rounded-2xl border border-purple-400/30" />

          <div className="relative rounded-2xl overflow-hidden ring-1 ring-white/10 shadow-2xl glow-blue">
            <img
              src={siteData.images.team}
              alt="Cosmic nebula"
              className="w-full h-[460px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#05070d] via-transparent to-transparent" />

            {/* stat overlay */}
            <div className="absolute top-5 left-5 grad-border rounded-xl px-4 py-2 backdrop-blur">
              <p className="text-[10px] tracking-[0.25em] text-blue-300 font-semibold">UPTIME</p>
              <p className="text-xl font-bold text-white">99.98%</p>
            </div>
          </div>

          <div className="absolute -bottom-8 -right-4 md:-right-8 grad-border rounded-2xl p-4 max-w-[240px] backdrop-blur">
            <div className="flex items-center gap-2 text-blue-300">
              <Zap className="w-4 h-4" />
              <p className="text-[10px] tracking-[0.25em] font-semibold">RESPONSE TIME</p>
            </div>
            <p className="mt-1 text-2xl font-bold text-white">&lt; 1 hour</p>
            <p className="text-xs text-white/60 mt-1">for priority tickets, business hours</p>
          </div>
        </div>

        <div>
          <p className="text-xs font-semibold tracking-[0.25em] text-blue-400">
            {siteData.approach.eyebrow}
          </p>
          <h2 className="mt-3 text-3xl md:text-5xl font-bold tracking-tight text-white">
            Get the full benefit of the tech you already <span className="gradient-text">invested in.</span>
          </h2>
          <div className="mt-5 space-y-4 text-white/70 leading-relaxed">
            {siteData.approach.body.map((p, i) => (<p key={i}>{p}</p>))}
          </div>
          <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {siteData.approach.bullets.map((b, i) => (
              <li key={i} className="flex items-start gap-3 p-3 rounded-lg bg-white/[0.03] border border-white/10 hover:border-blue-400/40 transition-colors">
                <span className="mt-0.5 w-5 h-5 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center flex-shrink-0 shadow-[0_0_12px_-2px_rgba(99,102,241,0.8)]">
                  <Check className="w-3 h-3 text-white" strokeWidth={3} />
                </span>
                <span className="text-white/90 text-sm">{b}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Approach;
